<template>
  <div class="title">
    <h2 v-html="getTitle"></h2>
    <BaseStep v-if="isStep" :list="nowBookSteps" :nowIndex="nowIndex" />
  </div>
</template>

<script>
import BaseStep from "@/components/Base/BaseStep.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  name: "BaseTitle",

  components: {
    BaseStep,
  },

  props: {
    title: {
      type: String,
    },
    isStep: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const store = useStore();
    const route = useRoute();
    const bookSteps = computed(() => store.state.book.bookSteps);
    const etcBookSteps = computed(() => store.state.book.etcBookSteps);

    const nowBookSteps = computed(() => {
      return route.fullPath.includes("etc")
        ? etcBookSteps.value
        : bookSteps.value;
    });

    const nowIndex = computed(() => {
      return nowBookSteps.value.findIndex(
        (bookStep) => bookStep.page === route.name
      );
    });

    const getTitle = computed(
      () => props.title || nowBookSteps.value[nowIndex.value]?.pageName
    );
    return { nowBookSteps, nowIndex, getTitle };
  },
};
</script>
